<script>
import feather from 'feather-icons';
import ProjectsFilter from './ProjectsFilter.vue';
import ProjectSingleTile from './ProjectSingleTile.vue';
import projects from '../../data/projects';

export default {
	components: { ProjectSingleTile, ProjectsFilter },
	data: () => {
		return {
			projects,
			projectsHeading: 'Projects Portfolio',
			selectedCategory: '',
			searchProject: '',
		};
	},
	computed: {
		filteredProjects() {
			if (this.selectedCategory) {
				return this.filterProjectsByCategory();
			} else if (this.searchProject) {
				return this.filterProjectsBySearch();
			}
			return this.projects;
		},
	},
	methods: {
		filterProjectsByCategory() {
			return this.projects.filter((item) => {
      return item.categories.includes(this.selectedCategory);
    });
		},
		filterProjectsBySearch() {
			let project = new RegExp(this.searchProject, 'i');
			return this.projects.filter((el) => el.title.match(project));
		},
	},
	mounted() {
		feather.replace();
	},
};
</script>

<template>
  <section class="pt-10 sm:pt-14">
    <div class="text-center">
      <p class="font-general-semibold text-2xl sm:text-5xl font-semibold mb-2 text-ternary-dark dark:text-ternary-light">
        {{ projectsHeading }}
      </p>
    </div>
    <div class="mt-10 sm:mt-10">
      <h3 class="font-general-regular text-center text-secondary-dark dark:text-ternary-light text-md sm:text-xl font-normal mb-4">
        Search projects by title or filter by category
      </h3>
      <div class="flex justify-between border-b border-primary-light dark:border-secondary-dark pb-3 gap-2">
        <div class="flex justify-between gap-2">
          <span class="hidden sm:block bg-primary-light dark:bg-ternary-dark p-2.5 shadow-sm rounded-xl cursor-pointer">
            <i data-feather="search" class="text-ternary-dark dark:text-ternary-light"></i>
          </span>
          <input v-model="searchProject" class="font-general-medium pl-3 pr-1 max-w-[150px] sm:max-w-none sm:px-4 py-2 border-1 border-gray-200 dark:border-secondary-dark rounded-lg text-sm sm:text-md bg-secondary-light dark:bg-ternary-dark text-primary-dark dark:text-ternary-light" id="name" name="name" type="search" required="" placeholder="Search Projects" aria-label="Name" />
        </div>
        <ProjectsFilter @filter="selectedCategory = $event" />
      </div>
    </div>

    <div class="justify-items-center grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-6 gap-6 sm:gap-10">
    <router-link
      v-for="project in filteredProjects"
      :key="project.id"
      :to="'/projects/' + project.id"
    >
      <ProjectSingleTile :project="project" />
    </router-link>
  </div>
  </section>
</template>


<style scoped></style>
